(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["btwyn-human-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const homes = document.querySelectorAll('[data-story-home]');
    homes.forEach((home) => {
      if (home.dataset.storyReady === 'true') return;
      home.dataset.storyReady = 'true';

      const chapters = [...home.querySelectorAll('[data-story-chapter]')];
      const navLinks = [...home.querySelectorAll('.story-home__chapter-nav a')];

      const updateProgress = () => {
        const max = Math.max(1, home.scrollHeight - window.innerHeight);
        const passed = Math.min(max, Math.max(0, -home.getBoundingClientRect().top));
        home.style.setProperty('--story-progress-scale', String(passed / max));
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          chapters.forEach((chapter) => chapter.classList.toggle('is-visible', chapter === entry.target));
          navLinks.forEach((link) => link.removeAttribute('aria-current'));
          const activeLink = navLinks.find((link) => link.getAttribute('href') === `#${entry.target.id}`);
          if (activeLink) activeLink.setAttribute('aria-current', 'true');
        });
      }, { threshold: 0.56 });

      chapters.forEach((chapter) => observer.observe(chapter));
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('.btwyn-collection-density__btn');
    var grid = document.querySelector('[data-collection-grid]');
    if (!buttons.length || !grid) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        grid.classList.toggle('is-density-2', btn.getAttribute('data-density') === '2');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-two-paths"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var frame = document.querySelector('[data-merge-hero]');
    if (!frame) return;
    var a = frame.querySelector('[data-merge-track="a"] img');
    var b = frame.querySelector('[data-merge-track="b"] img');
    if (!a || !b) return;
    var ticking = false;
    function update() {
      var rect = frame.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
      var shiftA = progress * -18;
      var shiftB = progress * 12;
      a.style.transform = 'translateY(' + shiftA + 'px) scale(1.04)';
      b.style.transform = 'translateY(' + shiftB + 'px) scale(1.04)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    if (window.innerWidth > 991) return;
    var addBtn = document.getElementById('btwyn-product-add');
    var form = document.getElementById('btwyn-product-form');
    if (!addBtn || !form) return;
    var sticky = document.createElement('div');
    sticky.className = 'btwyn-product__sticky-bar';
    sticky.innerHTML = '<button type="button" class="btwyn-product__add font-mono">' + addBtn.textContent.trim() + '</button>';
    sticky.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:30;padding:0.75rem var(--page-margin);background:var(--color-bone);border-top:1px solid var(--color-ink);transform:translateY(100%);transition:transform 240ms ease-out;';
    document.body.appendChild(sticky);
    sticky.querySelector('button').addEventListener('click', function () {
      addBtn.click();
    });
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.style.transform = visible ? 'translateY(100%)' : 'translateY(0)';
    }, { threshold: 0 });
    observer.observe(addBtn);
  })();

  (function () {
    var mount = document.querySelector('[data-recommendations-url]');
    if (!mount) return;
    var url = mount.getAttribute('data-recommendations-url');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(mount.id);
        if (fresh && fresh.innerHTML.trim()) {
          mount.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
